<template>
  <div style="width:100%">
    <v-layout>
      <v-flex xs6>
        <v-card>
          <v-toolbar flat class="mb-0">
            <v-toolbar-title>New Student Accounts</v-toolbar-title>
            <v-spacer></v-spacer>

          </v-toolbar>
          <v-data-table
            :headers="table.headers"
            :items="items"
            :dense="true"
            :search="table.search"
            :sort-by="['name.familyName']"
            :hide-default-footer="true"
            :disable-pagination="true"
            :height="600"
          >
            <template v-slot:item.matches="{ item }">
              <div v-for="account in item.matches" :key="account.primaryEmail">{{ account.primaryEmail.split("@")[0] }}</div>
            </template>

            <template v-slot:item.actions="{ item }">
                  <v-icon
                    v-if="!item.created"
                    :color="item.selected ? 'red darken-4': 'grey lighten-2'"
                    @click="selectItem(item)"
                  >
                    add_box
                  </v-icon>
                  <div style="width:40px" v-if="item.created">
                    <v-icon
                      color="green"
                    >
                      checkmark
                    </v-icon>
                  </div>
              </template>
            </v-data-table>
            <v-card-subtitle>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    text
                    link
                    v-bind="attrs"
                    v-on="on"
                  >
                  {{ items.length }} imported from Skedula
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item
                    @click="sync"
                  >
                  <v-list-item-title>resync</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-card-subtitle>
          </v-card>
        </v-flex>
        <v-flex xs1></v-flex>
        <v-flex xs5 style="max-width:500px">
          <v-card v-if="showCard">
            <v-app-bar
                  flat
                  dark
                  color="black"
                >
                  <v-toolbar-title>New Student</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn
                    icon
                    style="float:right"
                    @click="closeItem"
                  >
                    <v-icon>close</v-icon>
                </v-btn>
            </v-app-bar>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex
                  xs12
                >
                  <v-text-field
                    v-model="newItem.uid"
                    label="ID"
                    readonly
                    :hide-details="true"
                  />
                </v-flex>
                <v-flex
                  xs6
                >
                  <v-text-field
                    v-model="newItem.first_name"
                    label="First Name"
                  />
                </v-flex>
                <v-flex
                  xs6
                >
                  <v-text-field
                    v-model="newItem.last_name"
                    label="Last Name"
                  />
                </v-flex>
                <v-flex
                  xs12
                >
                  <v-text-field
                    :hide-details="true"
                    v-model="newItem.name"
                    label="Display Name"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-subheader class="pl-0">GSuite Account </v-subheader>
                  <v-progress-linear
                    v-if="searchingGoogleAccount"
                    indeterminate
                    color="yellow darken-2"
                  ></v-progress-linear>
                  <v-simple-table dense>
                    <template v-slot:default>
                      <tbody>
                        <tr  v-for="item in gsuiteAccounts" :key="item.primaryEmail"
                          v-show="item.selected || newItem.email.length == 0"
                        >
                          <td class="pr-0">
                            <v-checkbox dense v-model="item.selected"
                                @click="linkGsuiteAccount(item)"
                            ></v-checkbox>
                          </td>
                          <td class="pl-0" style="font-size:12px">
                              {{ item.name.fullName }}
                          </td>
                          <td style="font-size:12px">
                            {{ item.email }}
                          </td>
                          <td style="font-size:12px">
                            {{ item.orgUnitPath }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-flex>
                <v-flex
                  xs12
                >
                  <v-text-field
                    v-model="newItem.email"
                    label="Email"
                    suffix="@townsendharris.org"
                    :hide-details="true"
                  />
                </v-flex>

                <v-flex
                  xs12
                >
                  <v-select
                    v-model="newItem.class_of"
                    :items="['2025','2024','2023','2022','2021']"
                    label="Class Of"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions style="padding-right:50px">
            <v-spacer />
            <v-btn
              :loading="saving"
              text
              @click="create"
            >
              submit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    </div>
</template>

<script>
const api = require('../apiFunctions.js')
const fb = require('../firebaseConfig.js')

var firstLettersMatch = (name1, name2) => {
  name1 = name1.toUpperCase()
  name2 = name2.toUpperCase()
  if (name1[0] === name2[0]) {
    if (Math.min(name1.length, name2.length) > 1) {
      return name1[1] == name2[1]
    } else {
      return true
    }
  }
  return false
}

export default {
  data: () => ({
    user: fb.session.user,
    selectedItem: null,
    showCard: false,
    newItem: {
      id: 0,
      uid: '',
      name:'',
      email:'',
      classOf: {}
    },
    studentEmailErrorMessage:'',
    searchingGoogleAccount: false,
    gsuiteAccounts: [],
    saving: false,
    params: {
      user_uid: '',
      target: '',
      table: '',
      limit: 100
    },
    items: [],
    table: {
      search: '',
      headers: [
        { text: 'First', value: 'first_name' },
        { text: 'Last', value: 'last_name' },
        { text: 'OSIS', value: 'osis' },
        { text: 'Matches', value: 'matches' },
        { text: '', value: 'actions', sortable: false },
      ]
    }
  }),
  watch: {
  },
  mounted () {
    this.getNewStudents()
  },
  methods: {
    getNewStudents: function () {
      var self = this
      api.get('getNewStudents', {}, (data) => {
        console.log(data)
        self.items = data.skedula
        data.skedula.forEach((skedula, i) => {
          skedula.matches = []
          data.gsuite.forEach((gsuite, i) => {

            gsuite.email = gsuite.primaryEmail.split("@")[0]
            gsuite.selected = false
            if (gsuite.name.familyName.toUpperCase() != skedula.last_name.toUpperCase()) {
              return
            }
            if (gsuite.name.givenName.toUpperCase() == skedula.first_name.toUpperCase()) {
              skedula.matches.push(gsuite)
            }
            else if (firstLettersMatch(gsuite.name.givenName, skedula.first_name)) {
              skedula.matches.push(gsuite)
            }
          })
        })
      })
    },
    getGSuiteAccounts: function () {
      api.get('getGSuiteAccounts', {}, (data) => {
        console.log('gsuiteAccounts', data.length)
      })
    },
    selectItem: function (item) {
      var self = this
      self.showCard = true
      if (self.selectedItem) {
        self.selectedItem.selected = false
      }

      console.log(item)
      self.selectedItem = item
      self.selectedItem.selected = true

      self.newItem = Object.assign(self.newItem, item)
      self.newItem.uid = self.newItem.osis
      self.newItem.name = self.newItem.first_name + " " + self.newItem.last_name
      self.newItem.email = ''

      self.gsuiteAccounts = self.selectedItem.matches

      if (self.gsuiteAccounts.length === 1){
        self.gsuiteAccounts[0].selected = true
        self.newItem.email = self.gsuiteAccounts[0].email
      }

      var gsuiteSearchParams = {
        familyName: self.selectedItem.last_name,
      }
      // self.searchingGoogleAccount = true
      // api.get('getGSuiteAccounts', gsuiteSearchParams, (data) => {
      //   var exactMatches = []
      //   data.forEach((item, i) => {
      //
      //     item.email = item.primaryEmail.split("@")[0]
      //     item.selected = false
      //
      //     self.searchingGoogleAccount = false
      //     if (item.name.givenName.toUpperCase() == self.selectedItem.first_name.toUpperCase()) {
      //       exactMatches.push(item)
      //     }
      //     if (firstLettersMatch(item.name.givenName, self.selectedItem.first_name)) {
      //       self.gsuiteAccounts.push(item)
      //     }
      //   })
      //   if (exactMatches.length > 0) {
      //     self.gsuiteAccounts = exactMatches
      //   }
      // })
    },
    linkGsuiteAccount: function (account) {
      var self = this
      account.selected = !account.selected
      if (account.selected) {
        account.selected = false
        self.newItem.email = ''
      } else {
        self.newItem.email = account.email
        self.gsuiteAccounts.forEach((item, i) => {
          item.selected = item.email === self.newItem.email
        });
      }
    },
    closeItem: function () {
      var self = this
      self.saving = false
      self.showCard = false
      self.selectedItem.selected = false
      this.newItem.email = ''

    },
    create: function () {
      var self = this
      if (self.newItem.email.length < 2) {
        alert('missing email mapping')
        return
      }
      if (!self.newItem.class_of) {
        alert('missing class of')
        return
      }
      self.saving = true
      api.students.save(self.newItem, (data) => {
        self.selectedItem.created = true
        self.closeItem()
      })
    },
    searchGoogleAccount: function () {

    },
    sync: function () {
      api.get('syncSkedulaStudents', {}, (data) => {
        this.getNewStudents()
      })
    }
  }
}
</script>
